import { ChangePassApi } from './ChangePassApi'
import { ProfileApi } from './ProfileApi'
import { ClientPostApi } from './ClientPostApi'
import { servicesLookup } from './Servicelookupapi'
import { Notificationpostapi } from './Notificationpostapi'
import { Projectapi } from './Projectapi'
import { PaymentApi } from './AddPaymentApi'
import { Transactionapi } from './TransactionApi'
const apiCalls={
    ChangePassApi,
    ProfileApi,
    ClientPostApi,
    servicesLookup,
    Notificationpostapi,
    Projectapi,
    PaymentApi,
    Transactionapi
}
export {apiCalls}